import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqItems = [
  {
    question: 'Was ist stapel.ai?',
    answer:
      'stapel.ai ist eine KI-gestützte Plattform zur automatischen Qualitätsprüfung von Vergabedokumenten. Wir helfen Vergabestellen, Leistungsbeschreibungen schneller und fehlerfrei zu erstellen — bevor sie veröffentlicht werden.',
  },
  {
    question: 'Wie funktioniert stapel.ai?',
    answer:
      'Sie laden Ihre Vergabedokumente (z. B. Leistungsverzeichnisse im GAEB-XML- oder PDF-Format) hoch. stapel.ai analysiert diese automatisch anhand von über 100 Qualitätskriterien und liefert Ihnen einen detaillierten Prüfbericht mit konkreten Handlungsempfehlungen.',
  },
  {
    question: 'Welche Dokumenttypen werden unterstützt?',
    answer:
      'stapel.ai unterstützt gängige Formate im Vergabewesen, darunter GAEB-XML, PDF und weitere strukturierte Dokumentformate. Wir erweitern die Formatunterstützung kontinuierlich basierend auf dem Feedback unserer Nutzer.',
  },
  {
    question: 'Ist stapel.ai DSGVO-konform?',
    answer:
      'Ja. Alle Daten werden ausschließlich in zertifizierten EU-Rechenzentren verarbeitet und gespeichert. Wir setzen auf Verschlüsselung, strenge Zugriffskontrollen und Privacy-by-Design-Prinzipien.',
  },
  {
    question: 'Wie schnell kann ich mit stapel.ai starten?',
    answer:
      'Der Onboarding-Prozess ist unkompliziert. Die meisten Vergabestellen arbeiten innerhalb weniger Tage produktiv mit der Plattform. Unser Team begleitet Sie bei der Einrichtung.',
  },
  {
    question: 'Werden meine Daten für KI-Training verwendet?',
    answer:
      'Nein. Ihre Dokumente und Daten werden niemals für das Training oder die Weiterentwicklung von KI-Modellen verwendet. Ihre Daten gehören Ihnen.',
  },
  {
    question: 'Welche Regelwerke prüft stapel.ai?',
    answer:
      'stapel.ai prüft unter anderem auf Konformität mit VOB/A, VgV, UVgO sowie Landes- und Bundesvorgaben. Unsere Regelwerk-Datenbank wird laufend aktualisiert und erweitert.',
  },
];

export function FAQ() {
  return (
    <section
      id="faq"
      className="flex flex-col items-center justify-center gap-10 pb-10 w-full relative"
    >
      <div className="absolute inset-0 -z-10 pointer-events-none">
        <div className="absolute inset-0 -z-10 w-full bg-gradient-to-b from-secondary via-background to-background" />
      </div>
      <div className="w-full h-full relative">
        <div className="p-10 md:p-14">
          <div className="max-w-xl mx-auto flex flex-col items-center justify-center gap-2">
            <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-center text-balance text-[#111]">
              Häufig gestellte Fragen
            </h2>
            <p className="text-muted-foreground text-center text-balance font-medium">
              Haben Sie weitere Fragen? Kontaktieren Sie uns unter{' '}
              <a
                href="mailto:kontakt@stapel.ai"
                className="underline text-primary"
              >
                kontakt@stapel.ai
              </a>
            </p>
          </div>
        </div>
        <div className="border-b w-full" />
      </div>
      <div className="max-w-3xl w-full mx-auto px-10">
        <Accordion type="single" collapsible className="grid gap-2">
          {faqItems.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-border rounded-lg px-4 bg-card/50"
            >
              <AccordionTrigger className="hover:no-underline py-3.5 cursor-pointer">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
